import { render, staticRenderFns } from "./SyncData.vue?vue&type=template&id=58e94754&scoped=true"
import script from "./SyncData.vue?vue&type=script&lang=js"
export * from "./SyncData.vue?vue&type=script&lang=js"
import style0 from "./SyncData.vue?vue&type=style&index=0&id=58e94754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e94754",
  null
  
)

export default component.exports